export default function getParamsFromUrl(path: string): string | null {
  try {
    const url = window.location.href
    const urlObj = new URL(url)
    const params = new URLSearchParams(urlObj.search)
    return params.get(path) || null
  } catch (error) {
    console.error('Error parsing URL:', error)
    return null
  }
}
